import { useState } from 'react';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { Button } from 'components/common';

interface Props {
  guestLoginOnly?: boolean;
  isHomePageLogin?: boolean;
  next?: string;
}

const GuestLogin = ({
  guestLoginOnly,
  isHomePageLogin = false,
  next
}: Props) => {
  const { dispatch } = useDispatch();
  const {
    language,
    messages,
    serverConfig: { loginPageGuestLoginButton }
  } = useReduxState();

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const existingCookieGuestId = decodeURIComponent(
        document.cookie.replace(
          /(?:(?:^|.*;\s*)guestId\s*=\s*([^;]*).*$)|^.*$/,
          '$1'
        )
      );
      const response = await api.post(`/auth/guest/authenticate`);
      if (response.data?.success) {
        // check if this is a new guest user and store the information
        // in session store so we can show an info modal in the reader
        const { guestId } = response.data.user;
        if (guestId !== existingCookieGuestId) {
          sessionStorage.setItem('vuoNewGuestId', guestId);
        }

        if (next) window.location.href = next;
      } else {
        throw new Error('error');
      }
    } catch (err) {
      setLoading(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  const defaultButtonText = isHomePageLogin
    ? guestLoginOnly
      ? messages.authSignIn
      : messages.loginGuestSignIn
    : guestLoginOnly
    ? messages.loginGuestLoginAlt
    : messages.loginGuestLogin;

  return (
    <div className="single-sign-on">
      <Button
        category="light"
        customBackgroundColor={loginPageGuestLoginButton?.backgroundColor}
        customBackgroundColorHover={
          loginPageGuestLoginButton?.backgroundColorHover
        }
        customColor={loginPageGuestLoginButton?.color}
        loading={loading}
        onClick={handleSubmit}
        text={
          loginPageGuestLoginButton?.textLocales?.[language] ||
          loginPageGuestLoginButton?.text ||
          defaultButtonText
        }
      />

      <style jsx>{`
        .single-sign-on:not(:first-child) {
          margin-top: 15px;
        }
        .single-sign-on :global(button) {
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default GuestLogin;
